import React, { useState } from 'react'

// Redux
import { useDispatch } from 'react-redux';
import { setScrapeViewer } from '../../../store/components/BuildTargets.slice';

// Hooks
import useScrapeKeywords from '../../../hooks/ScrapedKeywords/useScrapeKeywords';

// Helper
import { formateDateTime } from '../../../utils/MainHelper';

// Components
import { Button } from "antd";
import { ArrowLeftOutlined, PlusSquareOutlined, SyncOutlined } from "@ant-design/icons";
import CustomTable from '../../../customcomponents/customtable/CustomTable';
import ScraperModal from './ScraperModal/ScraperModal';

const ScrapedKeywords = () => {
    const dispatch = useDispatch();

    const { loading, keywords, addKeywords, getListKeywords } = useScrapeKeywords();
    const [openModal, setOpenModal] = useState(false)

    const columns = [
        {
            title: "Topic/Brand",
            dataIndex: "keyword",
            key: "keyword",
            sorter: (a, b) => a.keyword?.localeCompare(b?.keyword),
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: "50mm",
            align: "center",
            sorter: (a, b) => a.status.localeCompare(b.status),
            render: (text, { status, percentage }) => {
                return renderStatus(status, percentage)
            },
        },
        {
            title: "Remarks",
            dataIndex: "remarks",
            key: "remarks",
            align: "center",
            sorter: (a, b) => a.remarks.localeCompare(b.remarks),
            render: (text) => {
                if (text === "Has data") return <p style={{ color: "var(--emerald-500)" }}>{text}</p>
                else return <p style={{ color: "#FF4D4F" }}>{text}</p>
            },
        },
        {
            title: "Added By",
            dataIndex: "user",
            key: "user",
            width: "50mm",
            align: "center",
            sorter: (a, b) => a.user.localeCompare(b.user),
        },
        {
            title: "Date & Time Created",
            dataIndex: "date_created",
            key: "date_created",
            width: "70mm",
            align: "center",
            render: (text) => {
                if (!text) return "-";
                return formateDateTime(text);
            },
            sorter: {
                compare: (a, b) => {
                    var date1 = new Date(a.date_created);
                    var date2 = new Date(b.date_created);
                    return date1 - date2;
                },
            },
        },
        {
            title: "Date & Time Modified",
            dataIndex: "last_status_update",
            key: "last_status_update",
            width: "70mm",
            align: "center",
            render: (text) => {
                if (!text) return "-";
                return formateDateTime(text);
            },
            sorter: {
                compare: (a, b) => {
                    var date1 = new Date(a.last_status_update);
                    var date2 = new Date(b.last_status_update);
                    return date1 - date2;
                },
            },
        },
    ];

    const handleBack = () => {
        dispatch(setScrapeViewer(false))
    }

    const handleScrape = () => {
        setOpenModal(true)
    }

    const handleRefresh = () => {
        getListKeywords()
    }

    const renderStatus = (status, percentage) => {
        const style = {
            display: "inline-block",
            padding: "2px 8px",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            borderRadius: "3px",
            fontSize: "12px",
            border: status.toLowerCase() === "done" ? "0px solid var(--emerald-300)" : "var(--blue-300)",
            color: status.toLowerCase() === "done" ? "var(--emerald-500)" : "var(--blue-500)",
            background: status.toLowerCase() === "done" ? "var(--emerald-100)" : "var(--blue-100)",
        }

        return <p style={style}>{`${status} ${status.toLowerCase() !== "done" ? `- ${percentage.toFixed(2)}%` : ""}`}</p>
    }

    return (
        <>
            <div className='oi-scraped-keywords'>
                <div className='oi-scraped-keywords-header'>
                    <Button type='link' icon={<ArrowLeftOutlined />} onClick={handleBack}>Back</Button>
                    <div className='oi-scraped-keywords-header-title'>
                        <b className='report--title'>List of Topic/Brand</b>
                        <div>

                            <Button type='link' icon={<PlusSquareOutlined />} onClick={handleScrape}>Add Topic/Brand</Button>
                            <Button type='link' icon={<SyncOutlined />} onClick={handleRefresh}>Refresh</Button>
                        </div>
                    </div>
                </div>
                <div className='oi-scraped-keywords-content'>
                    <CustomTable
                        loading={loading}
                        noCheckbox
                        columns={columns}
                        dataSource={keywords}
                        numColProps={{ width: "50px", align: "center", }}
                        scroll={{ y: "100vh", x: 1400 }}
                    />
                </div>
            </div>
            <ScraperModal {...{ openModal, setOpenModal, addKeywords, getListKeywords }} />
        </>
    )
}

export default ScrapedKeywords